<section
  class="rs-drawer-header"
  [class]="{'justify-content-between': displayClose()}"
>
  @if (displayClose()) {
  <button
    (click)="onClose.emit()"
    data-testid="rs-overview-filters--close-button"
    mat-icon-button
    type='button'
  >
    <mat-icon fontIcon="close" />
  </button>
  }

  <div class="action-buttons">
    @if (!hideClearFiltersButton()) {
    <button
      (click)="onClearFilters.emit()"
      class="rs-btn--secondary"
      data-testid="rs-overview-filters--clear-button"
      mat-button
    >
      {{ "CLEAR_FILTERS" | translate }}
    </button>
    }

    <button
      (click)='onApply.emit()'
      [disabled]="!canApply()"
      class="rs-btn--primary"
      data-testid="rs-overview-filters--apply-button"
      mat-button
    >
      {{ "APPLY_FILTERS" | translate }}
    </button>
  </div>
</section>

<section class="rs-drawer-content">
  <ng-content></ng-content>
</section>